import React from 'react';
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap';
import {
    MapboxControlButton,
    MapboxControlGroup,
    createReactMapboxControl
} from '../../../utils/mapbox/Mapbox';
import SubscriptionTooltip from '../SubscriptionTooltip';
import {stringifyUrlProps} from '../urlProps';

export interface FullscreenControlProps {
    highlight: MapHighlight;
    bounds: mapboxgl.LngLatBounds | undefined;
    zoom: number | undefined;
    userLayers: UserLayer[] | undefined;
}
export default createReactMapboxControl(({
    bounds,
    zoom,
    highlight,
    userLayers,
}: FullscreenControlProps) => {
    const center = bounds && bounds.getCenter();

    return <MapboxControlGroup>
        <MapboxControlButton
            onClick={() => {
                if (!userLayers) return;
                window.location.assign('/map/' + stringifyUrlProps({
                    center,
                    zoom,
                    highlight,
                    layers: userLayers
                        .filter(({isVisible}) => isVisible)
                        .map(({layer}) => layer.type)
                }));
            }}
        >
            <SubscriptionTooltip enterDelay={750} placement='right' title='Fullscreen'>
                <ZoomOutMapIcon style={{width: 24, height: 24}} />
            </SubscriptionTooltip>
        </MapboxControlButton>
    </MapboxControlGroup>;
});
